import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {RgpdResponseDTO} from '../../../model/dto/rgpd-response.dto';
import {YoungViewModel} from '../../../components/young-info/young-info-view-model/YoungViewModel';
import {Year} from '../../../model/user/year.model';
import {getLatestImageRight} from '../../../model/user/young-image-right.model';
import {dateInscription} from '../../../../environments/environment';
import {Season} from "../../helper/season.model";
import { NgIf } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-dialog-rights',
    templateUrl: './dialog-rights.component.html',
    styleUrls: ['./dialog-rights.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, MatDialogContent, MatExpansionModule, MatCheckboxModule, NgIf, MatDialogActions]
})
export class DialogRightsComponent implements OnInit {
    readonly dialogRef = inject<MatDialogRef<DialogRightsComponent>>(MatDialogRef);
    private readonly fb = inject(UntypedFormBuilder);


    formGroupRGPD: UntypedFormGroup = null;
    year: Year;
    rgpdResponse: RgpdResponseDTO;
    young: YoungViewModel;
    isMinor: boolean;
    emptyForm = false;

    get legalResponsibleName() {
        if (this.young?.legalResponsibles?.length > 0) {
            return `${this.young.legalResponsibles[0].firstname} ${this.young.legalResponsibles[0].lastname?.toUpperCase()}`;
        }
        return '';
    }

    get youngName() {
        if (this.young) {
            return `${this.young.firstname} ${this.young.lastname?.toUpperCase()}`;
        }
        return '';
    }

    get scolarYears() {
        if (this.year) {
            return `${new Date(this.year.dateStart).getFullYear()}/${new Date(this.year.dateEnd).getFullYear()}`;
        }
        return '';
    }

    get yearStart() {
        return new Date(this.year.dateStart).getFullYear();
    }

    get yearEnd() {
        return new Date(this.year.dateEnd).getFullYear();
    }

    ngOnInit() {
        this.formGroupRGPD = this.fb.group({
            isRGPDReaded: [null, Validators.required],
            canTakePhotos: [null],
            canContactResponsable: [null],
            canComeAlone: true,
            cantComeAlone: false
        });

        this.rgpdResponse = new RgpdResponseDTO();

        this.formGroupRGPD.controls.canTakePhotos.valueChanges.subscribe((value: boolean) => {
            this.rgpdResponse.canTakePhotos = value;
        });
        this.formGroupRGPD.controls.isRGPDReaded.valueChanges.subscribe((value: boolean) => {
            this.rgpdResponse.isRGPDReaded = value;
        });
        this.formGroupRGPD.controls.canContactResponsable.valueChanges.subscribe((value: boolean) => {
            this.rgpdResponse.canContactResponsable = value;
        });

        this.formGroupRGPD.controls.canComeAlone.valueChanges.subscribe((value: boolean) => {
          if (value) {
            this.rgpdResponse.comeAlone = true;
            if (this.formGroupRGPD.controls.cantComeAlone.value) {
              this.formGroupRGPD.controls.cantComeAlone.setValue(false);
            }
          }

        });

      this.formGroupRGPD.controls.cantComeAlone.valueChanges.subscribe((value: boolean) => {
        if (value) {
          this.rgpdResponse.comeAlone = false;
          if (this.formGroupRGPD.controls.canComeAlone.value) {
            this.formGroupRGPD.controls.canComeAlone.setValue(false);
          }
        }
      });

      this.initWithYear();
    }

    closePopup() {
        this.dialogRef.close();
    }

    updateRights() {
        this.dialogRef.close(this.rgpdResponse);
    }

    private initWithYear() {
        if (this.year) {
            this.formGroupRGPD.controls.canTakePhotos.setValue(
                this.young.youngImageRights?.length > 0
                    ? getLatestImageRight(this.young.youngImageRights).hasImageRight : false);

            if (!this.emptyForm || (!this.year.acceptedRGPDDate || !this.year.contactAcceptedDate)) {
                this.formGroupRGPD.controls.isRGPDReaded.setValue(this.year.acceptedRGPD ? this.year.acceptedRGPD : false);
                this.formGroupRGPD.controls.canContactResponsable.setValue(this.year.contactAccepted ? this.year.contactAccepted : false);


                this.rgpdResponse.idYear = this.year.id;

                const season = new Season();
                const acceptedRGPD = new Date(this.year.acceptedRGPDDate);
                const contactAccepted = new Date(this.year.contactAcceptedDate);

                this.disableCheckbox(acceptedRGPD, season, contactAccepted);
            }

          if (this.year.comeAlone !== null) {
            if (this.year.comeAlone!) {
              this.formGroupRGPD.controls.canComeAlone.setValue(true);
            } else {
              this.formGroupRGPD.controls.cantComeAlone.setValue(true);
            }
          } else {
            this.formGroupRGPD.controls.canComeAlone.setValue(true);
          }
        }
    }

    private disableCheckbox(acceptedRGPD: Date, season: Season, contactAccepted: Date) {
        if (this.year.acceptedRGPD
            && (acceptedRGPD >= new Date(dateInscription.limitDate)
                || acceptedRGPD >= season.dateStart)) {
            this.formGroupRGPD.controls.isRGPDReaded.disable();
        }

        if (this.year.contactAccepted
            && (contactAccepted >= new Date(dateInscription.limitDate)
                || acceptedRGPD >= season.dateStart)) {
            this.formGroupRGPD.controls.canContactResponsable.disable();
        }

        if (this.year.comeAlone) {
            this.formGroupRGPD.controls.canComeAlone.disable();
            this.formGroupRGPD.controls.cantComeAlone.disable();
        }
    }
}
